<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingIcon",
  props: {
    scale: {
      type: Number,
      default: () => 1,
    },
    color: {
      type: String,
      default: () => "rgb(var(--color-gray-900))",
    },
  },
});
</script>

<template>
  <div class="loader" :style="{ scale, borderRightColor: color }"></div>
</template>

<style scoped lang="scss">
.loader {
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid #0000;
  position: relative;
  animation: l24 1s infinite linear;
}
.loader:before,
.loader:after {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: inherit;
  animation: inherit;
  animation-duration: 2s;
}
.loader:after {
  animation-duration: 4s;
}
@keyframes l24 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
